export const getShowcaseScrollState = ({ scrollLeft, clientWidth, scrollWidth }) => {
    const maxScroll = Math.max(0, scrollWidth - clientWidth);
    const boundaryTolerance = 12;

    return {
        atStart: scrollLeft <= boundaryTolerance,
        atEnd: scrollLeft >= maxScroll - boundaryTolerance
    };
};

export const getSpectrumSelectionStatus = (label) => {
    const colorName = label
        .replace(/^Select\s+/i, '')
        .replace(/\s+showcase color$/i, '')
        .trim();

    return `${colorName} selected`;
};

export const getSpectrumScrollBehavior = (reduceMotion) => reduceMotion ? 'auto' : 'smooth';
